/* eslint-disable camelcase */
import React from 'react';

import { Form } from 'cvlib';
import { useDispatch, useSelector } from 'react-redux';
import { hidePinForm } from 'containers/PinForm/actions/pinForm.actions';
import { PropTypes } from 'prop-types';

const style = {
  width: '136px',
  height: '40px',
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.35rem',
};

const ErrorModal = ({ errorMessage }) => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;

  const elements = [
    {
      element: 'subtitle',
      content: errorMessage,
      style: { paddingTop: '1.75rem' },
    },
    {
      element: 'button',
      type: 'red',
      content: translate('reset_password_btn_accept_new_password'),
      expand: 1,
      style,
      className: 'redButton',
      onClick: () => {
        dispatch(hidePinForm());
      },
    },
  ];

  return <Form elements={elements} classes={['pin-form-container']} />;
};

ErrorModal.propTypes = {
  errorMessage: PropTypes.string,
};

export default ErrorModal;
